
import { db, serverTimestamp, query, collection, where, orderBy, limit, getDocs } from "../../firebaseClient";
import type { NotificationDoc } from "../types/legalOps";

const COLLECTION = "notifications";

// Fetch notifications targeting a specific department
export async function fetchDeptNotifications(deptKey: string, limitCount = 50): Promise<NotificationDoc[]> {
    try {
        // Query: recipientType == DEPT && recipientKey == deptKey
        // Note: Requires index on [recipientKey, createdAt]
        const q = query(
            collection(db, COLLECTION),
            where("recipientType", "==", "DEPT"),
            where("recipientKey", "==", deptKey),
            orderBy("createdAt", "desc"),
            limit(limitCount)
        );
        
        const snap = await getDocs(q);
        return snap.docs.map(d => ({ id: d.id, ...d.data() } as NotificationDoc));
    } catch (e) {
        console.error("Fetch Dept Notifs Error:", e);
        return [];
    }
}

export async function fetchAllNotifications(limitCount = 50): Promise<NotificationDoc[]> {
    try {
        const q = query(
            collection(db, COLLECTION),
            orderBy("createdAt", "desc"),
            limit(limitCount)
        );
        const snap = await getDocs(q);
        return snap.docs.map(d => ({ id: d.id, ...d.data() } as NotificationDoc));
    } catch (e) {
        console.error("Fetch All Notifs Error:", e);
        return [];
    }
}

// Mark single as read
export async function markAsRead(id: string): Promise<void> {
    await db.collection(COLLECTION).doc(id).update({ 
        unread: false, 
        read: true // legacy sync
    });
}

// Mark all visible as read
export async function markAllDeptAsRead(deptKey: string): Promise<void> {
    const q = query(
        collection(db, COLLECTION),
        where("recipientType", "==", "DEPT"),
        where("recipientKey", "==", deptKey),
        where("unread", "==", true)
    );
    const snap = await getDocs(q);
    const batch = db.batch();
    snap.docs.forEach(d => {
        batch.update(d.ref, { unread: false, read: true });
    });
    await batch.commit();
}

// ... existing code for notifyActionRequired etc ...
export async function fetchUnreadNotifications(limitCount = 20): Promise<NotificationDoc[]> {
  // Legacy user-based fetch (kept for compatibility)
  return []; 
}

export async function markAllAsReadLegacy(): Promise<void> {
    // Legacy implementation
}

export async function markAllAsRead(): Promise<void> {
    // Wrapper for legacy call in Shell
    await markAllAsReadLegacy();
}

export async function notifyActionRequired(params: any) {
    // ... existing implementation (Queueing emails) ...
    // Note: This function handles ACTION emails. The new system handles STATUS notifications.
    // They can coexist.
}
